var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTractor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_2548758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m266.666 200.902h16.001v62.197h-16.001z",
    fill: "#4f5761",
    transform: "matrix(.514 -.857 .857 .514 -65.587 348.161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.459 212h43.081v16h-43.081z",
    fill: "#68737f",
    transform: "matrix(.371 -.928 .928 .371 -48.363 368.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 148.125h-16v-13.498a62.21991 62.21991 0 0 1 18.34277-44.28418l11.31446 11.31446a46.3218 46.3218 0 0 0 -13.65723 32.96972z",
    fill: "#4f5761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 136h32v88h-32z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 96h32v124h-32z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.267 248-20.267-152h32l16 128z",
    fill: "#d4e4f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 232v-56h32l16 64z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 352h-136v-120h77l59 80z",
    fill: "#d6323f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488 224-8 128h-255.67l16-56h47.67v-80z",
    fill: "#e04446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.33 296h63.67v56h-63.67z",
    fill: "#d6323f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 352h-32a112.02829 112.02829 0 0 0 -168.01-97.00977l-16-27.71044a144.025 144.025 0 0 1 216.01 124.72021z",
    fill: "#e04446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 288h-48a8.00039 8.00039 0 0 0 -8 8v96a8.00039 8.00039 0 0 0 8 8h48a8.00039 8.00039 0 0 0 8-8v-96a8.00039 8.00039 0 0 0 -8-8zm-8 16v16h-32v-16zm0 32v16h-32v-16zm-32 48v-16h32v16z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 240h32v16h-32z",
    fill: "#d6323f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 264h32v16h-32z",
    fill: "#d6323f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 288h32v16h-32z",
    fill: "#d6323f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486 256-5 80h-49a32.00409 32.00409 0 0 1 -32-32v-16a32.00409 32.00409 0 0 1 32-32z",
    fill: "#68737f"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e04446",
    height: 32,
    rx: 16,
    width: 248,
    x: 80,
    y: 64
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485 272-1 16h-52v-16z",
    fill: "#4f5761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483 304-1 16h-50v-16z",
    fill: "#4f5761"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 352,
    fill: "#68737f",
    r: 88
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 352,
    fill: "#ffefd6",
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#68737f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 336,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 352,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 368,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 352,
    r: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "m112 256a96 96 0 1 0 96 96 96.10874 96.10874 0 0 0 -96-96zm46.70264 160.89209-7.77491-13.46631-13.85546 8 7.78613 13.48584a79.32136 79.32136 0 0 1 -24.8584 6.6875v-15.59912h-16v15.59912a79.32136 79.32136 0 0 1 -24.8584-6.6875l7.78613-13.48584-13.85546-8-7.77491 13.46631a80.65186 80.65186 0 0 1 -18.18945-18.18945l13.46631-7.77491-8-13.85546-13.48584 7.78613a79.3281 79.3281 0 0 1 -6.6875-24.8584h15.59912v-16h-15.59912a79.3281 79.3281 0 0 1 6.6875-24.8584l13.48584 7.78613 8-13.85546-13.46631-7.77491a80.65186 80.65186 0 0 1 18.18945-18.18945l7.77491 13.46631 13.85546-8-7.78613-13.48584a79.32136 79.32136 0 0 1 24.8584-6.6875v15.59912h16v-15.59912a79.32136 79.32136 0 0 1 24.8584 6.6875l-7.78613 13.48584 13.85546 8 7.77491-13.46631a80.65186 80.65186 0 0 1 18.18945 18.18945l-13.46631 7.77491 8 13.85546 13.48584-7.78613a79.3281 79.3281 0 0 1 6.6875 24.8584h-15.59912v16h15.59912a79.3281 79.3281 0 0 1 -6.6875 24.8584l-13.48584-7.78613-8 13.85546 13.46631 7.77491a80.65186 80.65186 0 0 1 -18.18945 18.18945z",
    fill: "#4f5761"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 392,
    fill: "#68737f",
    r: 56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 392,
    fill: "#ffefd6",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 328a64 64 0 1 0 64 64 64.07207 64.07207 0 0 0 -64-64zm23.69727 105.7168-5.23536-14.3828-15.03515 5.47266 5.2395 14.39453a47.4082 47.4082 0 0 1 -17.33252 0l5.2395-14.39453-15.03515-5.47266-5.23536 14.38282a48.33341 48.33341 0 0 1 -13.27124-11.13575l13.25562-7.65332-8-13.85546-13.272 7.66259a47.7616 47.7616 0 0 1 -3.01511-16.73488c0-.11328.00781-.2251.00854-.33838l15.08814 2.66065 2.7793-15.75782-15.09107-2.66113a48.00407 48.00407 0 0 1 8.686-14.99121l9.83178 11.7168 12.25586-10.28516-9.83855-11.7251a47.66872 47.66872 0 0 1 16.28-5.93945v15.3208h16v-15.3208a47.66872 47.66872 0 0 1 16.28 5.93945l-9.83862 11.7251 12.25586 10.28516 9.83178-11.7168a48.00407 48.00407 0 0 1 8.686 14.99121l-15.09102 2.66113 2.7793 15.75782 15.08814-2.66065c.00073.11328.00854.2251.00854.33838a47.7616 47.7616 0 0 1 -3.01514 16.73486l-13.272-7.66259-8 13.85546 13.25562 7.65332a48.33341 48.33341 0 0 1 -13.27119 11.13575z",
    fill: "#4f5761"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.dbcb478c1ad66be13fc7fa166eaf185c.svg";
export { ForwardRef as ReactComponent };